import {
  primitiveColor
} from "./chunk-APYG7AGM.mjs";

// src/data.ts
var DEFAULT_TOAST_PROPS = {
  size: {
    mobile: "md",
    desktop: "lg"
  },
  position: {
    mobile: "bottom-center",
    desktop: "top-center"
  },
  offset: {
    mobile: 16,
    desktop: 40
  },
  duration: 2500,
  immediateDismiss: false,
  immediateEnter: false,
  messageColor: primitiveColor.neutral[0],
  stretch: {
    mobile: false,
    desktop: false
  }
};

export {
  DEFAULT_TOAST_PROPS
};
